import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { COMMON_WEB_PATH } from '@/constant';

const PrevButton = ({ onConfirm, fallbackPath = '/' } = {}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (typeof onConfirm === 'function') {
      onConfirm();
      return;
    }

    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      // 如果沒有上一頁，就去預設路徑，並使用 replace 避免產生新的歷史紀錄
      navigate(fallbackPath, { replace: true });
    }
  };
  return (
    <Box
      onClick={handleClick}
      position="absolute"
      top="-20px"
      right="-20px"
      w="80px"
      h="70px"
      bgImage={`url('${COMMON_WEB_PATH}/blue-layout/bet-record/bet_record_close.png')`}
      bgSize="100% 100%"
      bgPos="center"
      cursor="pointer"
    ></Box>
  );
};

export default PrevButton;
